import { Button, Checkbox } from "@alternative/components";
import { IconNames } from "@alternative/icons";
import React, { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { colorTypes } from "../../constants";
import { colorDbState, selTableIDState, selColorRowsState, scrollToViewIndRow } from "../../recoil/coloreditor/atoms";
import classNames from "classnames";
const EditableListItem = (props) => {
  const ref = useRef();
  const { colorRow, colorIndex, dragHandleProps } = props;
  const [colorTables, setColorTables] = useRecoilState(colorDbState);
  const selTableId = useRecoilValue(selTableIDState);
  const [colorRowState, setColorRowState] = useState(colorRow);
  const [selColRows, setSelColRows] = useRecoilState(selColorRowsState);
  const isSelected = selColRows.includes(colorIndex);
  useEffect(() => setColorRowState(colorRow), [colorRow]);
  const handleInputBlur = () => {
    //TODO: optimize this step
    const colorTable = colorTables[selTableId];
    const colorRowsTemp = colorTable.ColorRows.slice();
    colorRowsTemp[colorIndex] = colorRowState;
    const colorTableNew = { ...colorTable, ColorRows: colorRowsTemp };
    const colorTablesTemp = colorTables.slice();
    colorTablesTemp.splice(selTableId, 1, colorTableNew);
    setColorTables(colorTablesTemp);
  };
  const handleDelete = () => {
    const colorTable = colorTables[selTableId];
    const colorRowsTemp = colorTable.ColorRows.slice();
    colorRowsTemp.splice(colorIndex, 1);
    const colorTableNew = { ...colorTable, ColorRows: colorRowsTemp };
    const colorTablesTemp = colorTables.slice();
    colorTablesTemp.splice(selTableId, 1, colorTableNew);
    setColorTables(colorTablesTemp);
    setSelColRows([]);
  };
  const handleSelect = (e) => {
    let newSelRows = [];
    if (isSelected) {
      newSelRows = selColRows.filter((item) => item !== colorIndex);
    } else {
      newSelRows = [...selColRows, colorIndex].sort();
      if (e.shiftKey) {
        const lastIndex = selColRows[0];
        const selectionArr = new Array(Math.abs(lastIndex - colorIndex) + 1).fill(0);
        const fact = lastIndex - colorIndex < 0 ? 1 : -1;
        const selArr = selectionArr.map((item, i) => lastIndex + fact * i).sort();
        newSelRows = selArr;
      }
    }
    setSelColRows(newSelRows);
  };
  return (
    <div ref={ref} className={classNames("color-row-list", { "color-row-list--selected": isSelected })}>
      <div className="editable-swatch">
        {dragHandleProps && (
          <Button className="drag-handle" minimal {...dragHandleProps} icon={IconNames.HAMBURGER_MENU} />
        )}
        <span className="editable-swatch__colo-num">{colorIndex + 1}</span>
        <label>
          <Checkbox checked={isSelected} onClick={handleSelect} onChange={() => {}} />
        </label>
        <div className="editable-swatch__colo-prev" style={{ backgroundColor: colorRowState.FlatColor }}></div>
        <input
          className="editable-swatch__colo-value"
          value={colorRowState.FlatColor}
          onChange={(e) => {
            setColorRowState({ ...colorRowState, FlatColor: e.target.value });
          }}
          onBlur={handleInputBlur}
        />
        <input
          className="editable-swatch__colo-code"
          value={colorRowState.ColorCode}
          onChange={(e) => {
            setColorRowState({ ...colorRowState, ColorCode: e.target.value });
          }}
          onBlur={handleInputBlur}
        />
        <input
          className="editable-swatch__colo-name"
          value={colorRowState.ColorName}
          onChange={(e) => {
            setColorRowState({ ...colorRowState, ColorName: e.target.value });
          }}
          onBlur={handleInputBlur}
        />
        <select
          className="editable-swatch__colo-type"
          value={colorRowState.Type}
          onChange={(e) => {
            setColorRowState({ ...colorRowState, Type: Number(e.target.value) });
            handleInputBlur();
          }}
        >
          {colorTypes.map((colorType, i) => (
            <option key={i} value={i}>
              {colorType}
            </option>
          ))}
        </select>
        <span className="editable-swatch__tools">
          <Button icon={IconNames.DELETE} minimal onClick={handleDelete} />
        </span>
      </div>
      {colorRowState.YarnDetails.length > 1 && colorRowState.YarnDetails.map((item) => <EditableYarn />)}
    </div>
  );
};

const EditableYarn = () => {
  return (
    <div className="editable-ya-swatch">
      <div className="editable-ya-swatch__colo-prev" style={{ backgroundColor: "#ff0000" }}></div>
      <input className="editable-ya-swatch-value" value="#ff0000" onChange={() => {}}></input>
      <input className="editable-ya-swatch__colo-code" value="001" onChange={() => {}}></input>
      <input className="editable-ya-swatch__colo-name" value="Pale Lilac" onChange={() => {}}></input>
    </div>
  );
};
export default EditableListItem;
